import {TextField} from "@mui/material";
import React, {memo, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import type {PayerPayload} from "../../redux/AddNewTripPayerReducer.js";
import {updatePayer} from "../../redux/AddNewTripPayerReducer.js";
import APXNumberSelector from "../../reusables/APXNumberSelector.jsx";


export default memo(function AddNewPayerRow({index}) {
	  const [name, setName] = useState("");
	  const [payingFor, setPayingFor] = useState(1);
	  
	  const dispatch = useDispatch();
	  
	  useEffect(() => {
			 const payload: PayerPayload = {index, name, payingFor};
			 dispatch(updatePayer(payload));
	  }, [name, payingFor]);
	  
	  const handleNameChange = useCallback((event) => setName(event.target.value), []);
	  const handlePayingForChange = useCallback((event) => setPayingFor(Number(event.target.value)), []);
	  
	  return (
				 <>
						<TextField required sx={{width: "200%", mr: 2}} variant="outlined" label="Name"
									  value={name} onChange={handleNameChange}
						/>
						<APXNumberSelector required title="Paying for" value={payingFor} max={10} onChange={handlePayingForChange}/>
				 </>
	  );
});